// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Utilidades CSS Responsivas para SGEweb
   ============================================ */

/* === Clases de Visibilidad === */

/* Ocultar elementos solo en móvil */
@media (max-width: 768px) {
  .hide-mobile {
    display: none !important;
  }
}

/* Ocultar elementos solo en tablet */
@media (min-width: 769px) and (max-width: 1024px) {
  .hide-tablet {
    display: none !important;
  }
}

/* Ocultar elementos solo en desktop */
@media (min-width: 1025px) {
  .hide-desktop {
    display: none !important;
  }
}

/* Mostrar solo en móvil */
@media (min-width: 769px) {
  .show-mobile-only {
    display: none !important;
  }
}

/* === Cards Móviles para Listas === */

.mobile-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.mobile-card:active {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.mobile-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e9ecef;
}

.mobile-card .card-header strong {
  font-size: 1rem;
  color: #495057;
}

.mobile-card .card-body {
  margin-bottom: 8px;
}

.mobile-card .card-body p {
  margin: 4px 0;
  font-size: 0.9rem;
  color: #6c757d;
}

.mobile-card .card-body p strong {
  color: #212529;
  margin-right: 8px;
}

.mobile-card .card-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.mobile-card .card-actions button {
  flex: 1 1;
  min-width: 100px;
  font-size: 0.85rem;
  padding: 8px 12px;
}

/* === Scroll Horizontal Mejorado === */

.responsive-table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* Scroll suave en iOS */
  position: relative;
}

/* Indicador de scroll horizontal en móvil */
@media (max-width: 768px) {
  .responsive-table-wrapper::after {
    content: "← Desliza para ver más →";
    display: block;
    text-align: center;
    padding: 8px;
    background: #fff3cd;
    font-size: 0.85rem;
    color: #856404;
    border-top: 1px solid #ffeaa7;
  }

  /* Ocultar el indicador cuando no hay scroll */
  .responsive-table-wrapper.no-scroll::after {
    display: none;
  }
}

/* === Botones Responsivos === */

/* Stack vertical de botones en móvil */
@media (max-width: 768px) {
  .responsive-button-group {
    flex-direction: column !important;
  }

  .responsive-button-group .p-button {
    width: 100% !important;
    justify-content: center !important;
  }
}

/* === Tipografía Responsiva === */

@media (max-width: 768px) {
  .responsive-title {
    font-size: 1.2rem !important;
  }

  .responsive-subtitle {
    font-size: 1rem !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .responsive-title {
    font-size: 1.5rem !important;
  }

  .responsive-subtitle {
    font-size: 1.1rem !important;
  }
}

/* === Espaciado Responsivo === */

@media (max-width: 768px) {
  .responsive-spacing {
    padding: 8px !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .responsive-spacing {
    padding: 12px !important;
  }
}

@media (min-width: 1025px) {
  .responsive-spacing {
    padding: 16px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive-utils.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,kCAAkC;;AAElC,oCAAoC;AACpC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;;AAEtC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,uCAAuC;;AAEvC;EACE,gBAAgB;EAChB,iCAAiC,EAAE,wBAAwB;EAC3D,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE;IACE,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,6BAA6B;EAC/B;;EAEA,8CAA8C;EAC9C;IACE,aAAa;EACf;AACF;;AAEA,gCAAgC;;AAEhC,uCAAuC;AACvC;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;AACF;;AAEA,kCAAkC;;AAElC;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,iCAAiC;;AAEjC;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* ============================================\n   Utilidades CSS Responsivas para SGEweb\n   ============================================ */\n\n/* === Clases de Visibilidad === */\n\n/* Ocultar elementos solo en móvil */\n@media (max-width: 768px) {\n  .hide-mobile {\n    display: none !important;\n  }\n}\n\n/* Ocultar elementos solo en tablet */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .hide-tablet {\n    display: none !important;\n  }\n}\n\n/* Ocultar elementos solo en desktop */\n@media (min-width: 1025px) {\n  .hide-desktop {\n    display: none !important;\n  }\n}\n\n/* Mostrar solo en móvil */\n@media (min-width: 769px) {\n  .show-mobile-only {\n    display: none !important;\n  }\n}\n\n/* === Cards Móviles para Listas === */\n\n.mobile-card {\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 12px;\n  margin-bottom: 10px;\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.2s ease;\n}\n\n.mobile-card:active {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.mobile-card .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.mobile-card .card-header strong {\n  font-size: 1rem;\n  color: #495057;\n}\n\n.mobile-card .card-body {\n  margin-bottom: 8px;\n}\n\n.mobile-card .card-body p {\n  margin: 4px 0;\n  font-size: 0.9rem;\n  color: #6c757d;\n}\n\n.mobile-card .card-body p strong {\n  color: #212529;\n  margin-right: 8px;\n}\n\n.mobile-card .card-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n}\n\n.mobile-card .card-actions button {\n  flex: 1;\n  min-width: 100px;\n  font-size: 0.85rem;\n  padding: 8px 12px;\n}\n\n/* === Scroll Horizontal Mejorado === */\n\n.responsive-table-wrapper {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch; /* Scroll suave en iOS */\n  position: relative;\n}\n\n/* Indicador de scroll horizontal en móvil */\n@media (max-width: 768px) {\n  .responsive-table-wrapper::after {\n    content: \"← Desliza para ver más →\";\n    display: block;\n    text-align: center;\n    padding: 8px;\n    background: #fff3cd;\n    font-size: 0.85rem;\n    color: #856404;\n    border-top: 1px solid #ffeaa7;\n  }\n\n  /* Ocultar el indicador cuando no hay scroll */\n  .responsive-table-wrapper.no-scroll::after {\n    display: none;\n  }\n}\n\n/* === Botones Responsivos === */\n\n/* Stack vertical de botones en móvil */\n@media (max-width: 768px) {\n  .responsive-button-group {\n    flex-direction: column !important;\n  }\n\n  .responsive-button-group .p-button {\n    width: 100% !important;\n    justify-content: center !important;\n  }\n}\n\n/* === Tipografía Responsiva === */\n\n@media (max-width: 768px) {\n  .responsive-title {\n    font-size: 1.2rem !important;\n  }\n\n  .responsive-subtitle {\n    font-size: 1rem !important;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .responsive-title {\n    font-size: 1.5rem !important;\n  }\n\n  .responsive-subtitle {\n    font-size: 1.1rem !important;\n  }\n}\n\n/* === Espaciado Responsivo === */\n\n@media (max-width: 768px) {\n  .responsive-spacing {\n    padding: 8px !important;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .responsive-spacing {\n    padding: 12px !important;\n  }\n}\n\n@media (min-width: 1025px) {\n  .responsive-spacing {\n    padding: 16px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
